function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.87859C4.3431 1.87859 1.37859 4.8431 1.37859 8.5C1.37859 12.1569 4.3431 15.1214 8 15.1214C11.6569 15.1214 14.6214 12.1569 14.6214 8.5C14.6214 4.8431 11.6569 1.87859 8 1.87859ZM0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5ZM5.31938 5.81938C5.58857 5.5502 6.02501 5.5502 6.29419 5.81938L8 7.52519L9.70581 5.81938C9.97499 5.5502 10.4114 5.5502 10.6806 5.81938C10.9498 6.08857 10.9498 6.52501 10.6806 6.79419L8.97481 8.5L10.6806 10.2058C10.9498 10.475 10.9498 10.9114 10.6806 11.1806C10.4114 11.4498 9.97499 11.4498 9.70581 11.1806L8 9.47481L6.29419 11.1806C6.02501 11.4498 5.58857 11.4498 5.31938 11.1806C5.0502 10.9114 5.0502 10.475 5.31938 10.2058L7.02519 8.5L5.31938 6.79419C5.0502 6.52501 5.0502 6.08857 5.31938 5.81938Z",
  fill: "#F04438"
});

function SvgXCloseError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseError);
export default __webpack_public_path__ + "static/media/x-close-error.30a21391.svg";
export { ForwardRef as ReactComponent };